import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: "root",
})
export class ParamService {
  constructor(
    // @Inject('apiUrl') private apiUrl:string,
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  private get apiUrl(): string {
    return this.appConfig.apiUrl;
  }

  // getParameters() {
  //   console.log(this.apiUrl + 'api/param');
  //   return this.http.get(this.apiUrl + 'api/param');
  // }

  getParameters(): Observable<any> {
    console.log(this.apiUrl + "api/param");
    const queryParams = new HttpParams().set(
      "companyId",
      JSON.parse(sessionStorage.getItem("companyid")!),
    );
    return this.http.get(this.apiUrl + "api/param", { params: queryParams });
  }

  getLanguage(): Observable<any> {
    console.log(this.apiUrl + "api/param/language");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", JSON.parse(sessionStorage.getItem("username")!))
      .set("userType", JSON.parse(sessionStorage.getItem("usertype")!))
      .set("lng", JSON.parse(localStorage.getItem("language")!).id);
    return this.http.get(this.apiUrl + "api/param/language", {
      params: queryParams,
    });
  }

  postParameters(obj: any) {
    console.log(this.apiUrl + "api/param");
    return this.http.post(this.apiUrl + "api/param", obj);
  }

  getLanguageInfo(): Observable<any> {
    console.log(this.apiUrl + "api/param/language/label");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("lng", JSON.parse(localStorage.getItem("language")!).id);
    return this.http.get(this.apiUrl + "api/param/language/label", {
      params: queryParams,
    });
  }

  postLanguage(): Observable<any> {
    console.log(this.apiUrl + "api/param/language");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", JSON.parse(sessionStorage.getItem("username")!))
      .set("userType", JSON.parse(sessionStorage.getItem("usertype")!))
      .set("lng", JSON.parse(localStorage.getItem("language")!).id);
    return this.http.post(this.apiUrl + "api/param/language", {
      params: queryParams,
    });
  }

  getDateCalculation(obj: any) {
    console.log(obj);
    // console.log(obj);
    return this.http.post(this.apiUrl + "api/param/dateCalculation", obj);
    // let data= -this.http.post(this.apiUrl + 'api/param/DateCalculation',obj);
    // let p= Promise.resolve(data);
    // return p;
    // .(res => res.json()).toPromise();
  }

  // getDateCalculation2(obj) {
  //   console.log(this.apiUrl + 'api/param/DateCalculation');
  //   return this.http.post(this.apiUrl + 'api/param/DateCalculation',obj).toPromise().then(res=>res[0].gun);

  // };
}
